import { cartLineCardExpandedStyles as styles } from "@iewc/Overrides/Components/CartLineCardExpanded";
import { colorStrings, mediaQueriesBP } from "@iewc/Utilities/variables";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

const commonItemGridItem = css`
    flex: 1 1 auto !important;
    max-width: max-content !important;
    padding: 2px !important;
`;

styles.productPriceAndQuantityContainer = {
    ...styles.productPriceAndQuantityContainer,
    gap: 0,
    css: css`
        ${styles.productPriceAndQuantityContainer?.css};
    `,
    offsetCss: css`
        gap: 10px;

        ${mediaQueriesBP.minMD} {
            justify-content: flex-end;
        }

        ${mediaQueriesBP.minXLG} {
            justify-content: space-between;
            flex-wrap: nowrap !important;
            gap: 8px;
        }
    `,
};

styles.orderLineInfoContainer = {
    ...styles.orderLineInfoContainer,
    css: css`
        position: relative;
        min-height: 150px;
    `,
};

styles.estimatedShipDateLabel = {
    size: 14,
    weight: "bold",
    color: colorStrings.textMain,
    css: css`
        display: inline-flex;
        gap: 5px;
        padding: 0 5px;
    `,
};

styles.estimatedShipDateValue = {
    size: 14,
    color: colorStrings.textMain,
};

styles.estimatedShipDateItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        width: auto;
        max-width: max-content;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: flex-end;

        &.active {
            z-index: ${getProp("theme.zIndex.menu")};
        }

        ${mediaQueriesBP.minMD} {
            position: absolute;
            top: 70%;
            right: 0;
        }
    `,
};

styles.estimadedShipIcon = {
    color: colorStrings.primaryMain,
};

styles.changeShipDate = {
    size: 12,
    color: colorStrings.primaryMain,
    css: css`
        display: flex;
        align-items: center;
        gap: 5px;
    `,
};

styles.changeShipDateIcon = {
    size: 12,
    color: colorStrings.primaryMain,
};

styles.deliveryDatePicker = {
    clearIconProps: {
        css: css`
            display: none;
        `,
    },
    calendarIconProps: {
        css: css`
            display: none;
        `,
    },

    cssOverrides: {
        formField: css`
            position: relative;

            label {
                z-index: ${getProp("theme.zIndex.tabGroup")};
                pointer-events: none;
                cursor: pointer;
                background-color: ${getColor(colorStrings.commonBackground)};
            }
        `,
        formInputWrapper: css`
            position: absolute;
            margin: 0 !important;
            padding: 0;
            top: 0;
            left: 0;
            width: 100%;
            cursor: pointer;

            .react-datetime-picker,
            .react-datetime-picker__inputGroup__input {
                border: none !important;
                color: transparent !important;

                &::placeholder {
                    color: transparent !important;
                }
            }

            &&& input {
                pointer-events: none;
            }

            .react-datetime-picker .react-datetime-picker__button {
                padding: 0;
                width: 130px;
                margin-inline-start: -130px;
            }
        `,
    },
};

styles.badgeAreaWrapper = {
    css: css`
        position: relative;
    `,
};

styles.imageBadgeGridItem = {
    width: 12,
    css: css`
        display: block;
        min-height: 30px;
        padding: 0;
    `,
};

styles.badgeTextWrapper = {
    css: css`
        display: none;
        ${mediaQueriesBP.minMD} {
            position: absolute;
            width: auto;
            max-width: 100%;
            white-space: nowrap;
            overflow: hidden;
            height: max-content;
            & > div {
                height: 100%;
                line-height: normal;
                padding: 3px 10px;
                display: flex;
                align-items: center;
            }
        }
    `,
};

styles.badgeImageWrapper = {
    css: css`
        display: none;
        ${mediaQueriesBP.minMD} {
            position: absolute;
            width: 25%;
            height: 25%;
            left: 50%;
        }
    `,
};

styles.badgeText = {
    weight: "bold",
    size: 14,
    css: css`
        width: 100%;
        margin: auto;

        ${wrapInContainerStyles}
    `,
};

styles.imageBadgeGridItem = {
    width: 12,
    css: css`
        display: block;
        min-height: 30px;
        padding: 0 10px;
    `,
};

styles.textBadgeGridItem = {
    width: 12,
    css: css`
        display: block;
        min-height: 30px;
        padding: 0 10px;
    `,
};
styles.textBadgeStyles = {
    badge: {
        css: css`
            position: absolute;
            width: auto;
            max-width: 100%;
            white-space: nowrap;
            overflow: hidden;
            height: max-content;

            & > div {
                height: 100%;
                line-height: normal;
                padding: 3px 10px;
                display: flex;
                align-items: center;
            }
        `,
    },
    badgeText: {
        weight: "bold",
        size: 14,
        css: css`
            width: 100%;
            margin: auto;

            ${wrapInContainerStyles}
        `,
    },
};

styles.imageBadgeStyles = {
    container: {
        css: css`
            width: 60%;
            margin-bottom: 5px;
        `,
    },
    imageItem: {
        css: css`
            margin: 5px 0;
        `,
    },
};

styles.price = {
    ...styles.price,
    price: {
        ...styles.price?.price,
        priceText: {
            ...styles.price?.price?.priceText,
            css: css`
                ${styles.price?.price?.priceText?.css}

                &&& {
                    font-size: 16px;
                }
            `,
        },
    },
};

styles.extendedUnitNetPrice = {
    ...styles.extendedUnitNetPrice,
    text: {
        ...styles.extendedUnitNetPrice?.text,
        size: 22,
    },
};

styles.productAvailability = {
    container: {
        css: css`
            margin-bottom: 10px;
            padding-left: 5px;
        `,
    },
};

styles.putUpPriceText = {
    heading: {
        variant: "legend",
        size: 12,
    },
    text: {
        mergeCss: true,
        variant: "p",
        size: 14,
        transform: "uppercase",
        weight: 400,
        css: css`
            margin: 0;
        `,
    },
};

styles.quantity = {
    ...styles.quantity,
    readOnlyQuantityText: {
        ...styles.quantity?.readOnlyQuantityText,
        text: {
            mergeCss: true,
            variant: "p",
            size: 14,
            transform: "uppercase",
            weight: 400,
            css: css`
                margin: 0;
            `,
        },
    },
};

styles.price = {
    ...styles.price,
    price: {
        ...styles.price?.price,
        princingWrapper: {
            ...styles.price?.price?.princingWrapper,
            css: css`
                display: flex;
                flex-direction: column;
                align-items: flex-start;
            `,
        },
    },
};

styles.priceGridItem = {
    ...styles.priceGridItem,
    width: [12, 12, 3, 3, 3],
    css: css`
        ${commonItemGridItem}
    `,
};

styles.quantityGridItem = {
    ...styles.quantityGridItem,
    width: [12, 12, 3, 3, 3],
    css: css`
        ${commonItemGridItem}
    `,
};

styles.extendedUnitNetPriceGridItem = {
    ...styles.extendedUnitNetPriceGridItem,
    width: [12, 12, 3, 3, 3],
    css: css`
        ${commonItemGridItem}
    `,
};
